import { render, staticRenderFns } from "./Edited.vue?vue&type=template&id=6ba2789e&scoped=true&"
import script from "./Edited.vue?vue&type=script&lang=js&"
export * from "./Edited.vue?vue&type=script&lang=js&"
import style0 from "./Edited.vue?vue&type=style&index=0&id=6ba2789e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba2789e",
  null
  
)

export default component.exports